import ReferralPage from "./ReferralPage";
export default ReferralPage;
